import {PATH} from '@utils/Const'
import {RouteObject} from 'react-router-dom'
import ExamRoom from '@pages/ExamPage/ExamRoom/ExamRoom'
import RoadmapPage from '@pages/RoadmapPage'
import ExamPage from '@pages/ExamPage'
import ConverstationPage from '@pages/ConverstationPage'
import Health from '@pages/NonAuthentication/Health'
import GymPage from '@pages/GymPage'
import GymPronouncePage from '@pages/GymPage/GymPronouncePage'
import GymPairPage from '@pages/GymPage/GymPairPage'
import GymPracticePage from '@pages/GymPage/GymPracticePage'
import GymResultPage from '@pages/GymPage/GymResultPage'
import RevisePage from '@pages/LearnPage/RevisePage'
import ReviseRoom from '@pages/LearnPage/ReviseRoom'
import ExerciseComplete from '@pages/LearnPage/ReviseRoom/ExerciseComplete'
import ExamResult from '@pages/ExamPage/ExamResult'
import ExamHistory from '@pages/ExamPage/ExamHistory'
import Vocabulary from '@pages/LearnPage/Vocabulary'
import VocabularyResult from '@pages/LearnPage/VocabularyResult'
import LessonPage from '@pages/LearnPage/LessonPage/LessonPage'
import VocabularyOverview from '@pages/LearnPage/VocabularyOverview'
import GymVocabulary from '@pages/GymPage/GymVocabulary'
import ReviseSentence from '@pages/LearnPage/ReviseSentence'
import ReviseSentenceResult from '@pages/LearnPage/ReviseSentenceResult'
import ReviseSentenceOverview from '@pages/LearnPage/ReviseSentenceOverview'
import RoadmapSummary from '@pages/RoadmapPage/RoadmapSummary'
import PartTwo from '@pages/LearnPage/PartTwo'
import PartThree from '@pages/LearnPage/PartThree'
import LearnPage from '@pages/LearnPage'
import ParaphrasePage from '@pages/Paraphrase'
const authRoute: RouteObject[] = [
  {
    path: PATH.HOME,
    index: true,
    element: <RoadmapPage />,
  },
  {
    path: PATH.ROADMAP_SUMMARY,
    index: true,
    element: <RoadmapSummary />,
  },
  {
    path: PATH.GYM,
    index: true,
    element: <GymPage />,
  },
  {
    path: PATH.GYM_PRONOUNCE,
    index: true,
    element: <GymPronouncePage />,
  },
  {
    path: PATH.GYM_PAIR,
    index: true,
    element: <GymPairPage />,
  },
  {
    path: PATH.GYM_PRACTICE,
    index: true,
    element: <GymPracticePage />,
  },
  {
    path: PATH.GYM_RESULT,
    index: true,
    element: <GymResultPage />,
  },
  {
    path: PATH.GYM_VOCABULARY,
    index: true,
    element: <GymVocabulary />,
  },
  {
    path: PATH.EXAM,
    index: true,
    element: <ExamPage />,
  },
  {
    path: PATH.LEARN,
    index: true,
    element: <LearnPage />,
  },
  {
    path: PATH.LESSON_LEARN,
    index: true,
    element: <LessonPage />,
  },
  {
    path: PATH.CONVERSATION,
    element: <ConverstationPage />,
  },
  {
    path: PATH.EXAM_ROOM,
    element: <ExamRoom />,
  },
  {
    path: PATH.EXAM_RESULT,
    element: <ExamResult />,
  },
  {
    path: PATH.EXAM_HISTORY,
    element: <ExamHistory />,
  },
  {
    path: PATH.HEALTH,
    element: <Health />,
  },
  {
    path: PATH.LEARN_REVISE,
    index: true,
    element: <RevisePage />,
  },
  {
    path: PATH.LEARN_REVISE_ROOM,
    index: true,
    element: <ReviseRoom />,
  },
  {
    path: PATH.LEARN_REVISE_ROOM_COMPLETE,
    index: true,
    element: <ExerciseComplete />,
  },
  {
    path: PATH.LEARN_VOCABULARY,
    index: true,
    element: <Vocabulary />,
  },
  {
    path: PATH.LEARN_VOCABULARY_OVERVIEW,
    index: true,
    element: <VocabularyOverview />,
  },
  {
    path: PATH.LEARN_VOCABULARY_RESULT,
    index: true,
    element: <VocabularyResult />,
  },
  {
    path: PATH.LEARN_REVISE_SENTENCE,
    index: true,
    element: <ReviseSentence />,
  },
  {
    path: PATH.LEARN_REVISE_SENTENCE_RESULT,
    index: true,
    element: <ReviseSentenceResult />,
  },
  {
    path: PATH.LEARN_REVISE_SENTENCE_OVERVIEW,
    index: true,
    element: <ReviseSentenceOverview />,
  },
  {
    path: PATH.LEARN_PART_TWO,
    index: true,
    element: <PartTwo />,
  },
  {
    path: PATH.LEARN_PART_THREE,
    index: true,
    element: <PartThree />,
  },
  {
    path: PATH.PARAPHRASE_ROOM,
    index: true,
    element: <ParaphrasePage />,
  },
]

export default authRoute
